import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { ControlBase, ControlTextbox } from '../../../shared/forms';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { FileUpload } from '../../../shared/interfaces/fileupload';
import { Upload } from '../../../shared/interfaces/upload';
import { UploadFileService } from '../../../shared/services/upload-service';
import { StorageService } from '../../../shared/services/storage.service';
import { AlertService } from '../../../shared/services/alert.service';
import { OrganizationService } from '../../../shared/services/organization.service';
import { ProjectService } from '../../../shared/services/project.service';
import { Project } from '../../../shared/models/project';
import { GeocodingService } from '../../../shared/services/geocode.service';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { v4 as uuid } from 'uuid';
import * as firebase from 'firebase/app';
import * as _ from "lodash";
import { UtilityService } from '../../../shared/services/utility.service';
import { Observable, Subscription } from 'rxjs/Rx';
import { ElementRef, NgZone, ViewChild } from '@angular/core';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'appc-registerproject',
  templateUrl: './registerproject.component.html',
  styleUrls: ['./registerproject.component.scss']
})
export class RegisterprojectComponent implements OnInit {


  @ViewChild("projectAddress")
  public searchElementRef: ElementRef;
  public zoom: number;

  public websiteUrl: string;//craeted by venkat
  public webAddress: string;//created by venkat

  public facebookUrl: string;//created by venkat
  public facebookAddress: string;//created by venkat


  public twitterUrl: string;//created by venkat
  public twitterAddress: string;//created by venkat

  public youtubeUrl: string;//created by venkat
  public youtubeAddress: string;//created by venkat

  public linkedinUrl: string;//created by venkat
  public linkedinAddress: string;//created by venkat

  public displayErrorMessage: boolean;
  public errorMessage: string;
  public latitude: number;
  public longitude: number;

  public disablePreviousDates: string;// Riyan's creation

  private errors: string[];
  private controls: ControlBase<any>[];
  projectForm: FormGroup;

  projSpecializations: Array<string>;
  partnerOrganizations: Array<object>;
  leads: Array<object>;
  interventionMechanisms: Array<object>;
  projects: Array<object> = [];

  files: FileList;
  uploadedFiles: any[] = [];
  url: any;
  iconUrlProject: string;
  public lat: any;

  specialz: any;

  checked: boolean = false;
  activeColor: string = 'green';
  baseColor: string = '#ccc';
  overlayColor: string = 'rgba(255,255,255,0.5)';

  dragging: boolean = false;
  loaded: boolean = false;
  profileloaded: boolean = false;
  imageLoaded: boolean = false;
  profileimageLoaded: boolean = false;

  detailsloaded: boolean = false;
  challengesloaded: boolean = false;
  partnersloaded: boolean = false;
  projectsloaded: boolean = false;

  projectDetailsImageLoaded: boolean = false;
  projectChallengesImageLoaded: boolean = false;
  partnersLoaded: boolean = false;
  projectsLoaded: boolean = false;

  //-------Hide Progress Bar after upload----
  hideCoverPhotoProgress: boolean = false;
  hideProfilePhotoProgress: boolean = false;
  hideProjectDetailProgress: boolean = false;
  hideProjectChallengesProgress: boolean = false;
  hideProjectPartnersProgress: boolean = false;
  hideProjectImagesProgress: boolean = false;
  //-------Hide Progress Bar after upload----
  //Riyan:- code for resetting the choose files values when save and add project is clicked
  //-------input values of choose files------
  @ViewChild('coverPhotoInput')
  coverPhotoInputVariable: any;
  @ViewChild('profilePhotoInput')
  profilePhotoInputVariable: any;
  @ViewChild('projectDetailInput')
  projectDetailVariable: any;
  @ViewChild('projectChallengesInput')
  projectChallengesVariable: any;
  @ViewChild('projectPartnersInput')
  projectPartnersVariable: any;
  @ViewChild('projectImagesInput')
  projectImagesVariable: any;
  //-------input values of choose files------
  //Riyan:- code for resetting the choose files values when save and add project is clicked
  imageSrc: string = '../assets/img/empty.png';
  imageSrcName: string = '';
  profileimageSrc: string = '../assets/img/empty.png';
  profileimageName: string = '';

  iconColor: string;
  borderColor: string;


  selectedprojectcoverimagesFiles: FileList

  selectedprojectprofileimagesFiles: FileList

  projectcoverimagesFileUpload: FileUpload
  projectcoverimagesProgress: { percentage: number } = { percentage: 0 }

  projectprofileimagesFileUpload: FileUpload
  projectprofileimagesProgress: { percentage: number } = { percentage: 0 }


  selectedprojectdetailsFiles: FileList
  selectedprojectchallengesFiles: FileList
  selectedprojectpartnerslistFiles: FileList
  selectedprojectimagesFiles: FileList



  projectdetailsUpload: Upload;
  currentdetailsMulti: Array<any>

  projectchallengesUpload: Upload;
  currentchallengesMulti: Array<any>

  projectpartnerlistUpload: Upload;
  currentpartnerlistMulti: Array<any>

  projectimagesUpload: Upload;
  currentimagesMulti: Array<any>



  challengesArray: Array<any>

  detailsArray: Array<any>

  partnersArray: Array<any>

  projectsArray: Array<any>

  newProjSpec: Array<any>
  specialzs: Array<any>





  subscription: Subscription;
  newmode: boolean = true;
  project: FirebaseObjectObservable<any>;

  error: any = { isError: false, errorMessage: '' };

  budgetflag: boolean;
  public marker = {
    display: true,
    lat: null,
    lng: null,
    name: '',
    content: '',
    projId: '',
    orgId: '',
    projButton: false,
    orgButton: false,
    typeName: '',
    type: '',
    address: '',
    draggable: false,
    label: ''


  };



  constructor(
    public auth: AuthService,
    public db: AngularFireDatabase,
    public router: Router,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private organizationService: OrganizationService,
    private formBuilder: FormBuilder,
    private geocode: GeocodingService,
    private upSvc: UploadFileService,
    private alert: AlertService,
    private utility: UtilityService,
    private ref: ChangeDetectorRef,
    private ngZone: NgZone, private mapsAPILoader: MapsAPILoader,
    private projectService: ProjectService


  ) {

    this.iconUrlProject = '../../assets/img/markers/blue-dot.png'
  }

  private setCurrentPosition() {
    this.zoom = 2;

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {

        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;

        this.zoom = 2;
      });
    } else {
    }
  }
  compareTwoDates() {

    if (new Date(this.projectForm.controls['endDate'].value) < new Date(this.projectForm.controls['startDate'].value)) {
      this.error = { isError: true, errorMessage: 'End date should not before Start date' };
    } else {
      this.error = { isError: false };
    }
  }

  getProjPosition() {

    this.latitude = +this.storageService.getItem('projLatitude');
    this.longitude = +this.storageService.getItem('projLongitude');
    this.zoom = 2;
  }
  dragend(pos, $event) {
    this.displayErrorMessage = false;


    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;

    var latlng = new google.maps.LatLng(this.latitude, this.longitude);

    this.geocode.getLatLongDetail(latlng)
      .subscribe(address => {

        this.projectForm.controls['projectAddress'].setValue(address.formattedAddress)
        this.marker['projectAddress'] = address.formattedAddress
      })
  }

  selectAddress() {
    this.marker.display = !this.marker.display;

  }
  clicked() {

  }


  ngAfterViewInit() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  handleImageLoad() {
    this.imageLoaded = true;
    this.iconColor = this.overlayColor;
  }


  _handleReaderLoaded(e) {
    var reader = e.target;
    this.imageSrc = reader.result;
    this.loaded = true;
  }
  handleprofileImageLoad() {
    this.profileimageLoaded = true;
    this.iconColor = this.overlayColor;
  }


  _handleprofileReaderLoaded(e) {
    var reader = e.target;
    this.profileimageSrc = reader.result;
    this.profileloaded = true;
  }
  compareBudget() {
    var a = this.projectForm.value.budget
    let budgetalloc = parseInt(a);
    var b = this.projectForm.value.spent
    let budgetspent = parseInt(b);
    if (budgetalloc < budgetspent) {
      
      this.budgetflag = true;
      alert("Budget Spent can't be greater than Budget Allocated")
    } else {
      
      this.budgetflag = false;

    }
  }

  projectSpecialization: ProjectSpecializations[] = [{ id: 1, name: 'Adolescents and Youth', subName: 'Adolescents and Youth' }, 
  { id: 2, name: 'Agriculture', subName: 'Agrarian reform' },
  { id: 3, name: 'Agriculture', subName: 'Agricultural alternative Development' },
  { id: 4, name: 'Agriculture', subName: 'Agricultural Cooperatives' }, 
  { id: 5, name: 'Agriculture', subName: 'Agricultural Development' }, 
  { id: 6, name: 'Agriculture', subName: 'Agricultural education/training' },
  { id: 7, name: 'Agriculture', subName: 'Agricultural financial services' }, 
  { id: 8, name: 'Agriculture', subName: 'Agricultural inputs' }, 
  { id: 9, name: 'Agriculture', subName: 'Agricultural land resources' },
  { id: 10, name: 'Agriculture', subName: 'Agricultural Policy and Administrative Management Capacity Building' },
  { id: 11, name: 'Agriculture', subName: 'Agricultural research' },
  { id: 12, name: 'Agriculture', subName: 'Agricultural services' },
  { id: 13, name: 'Agriculture', subName: 'Agricultural water resources' }, 
  { id: 14, name: 'Agriculture', subName: 'Food crop production management and improvement' },
  { id: 15, name: 'Agriculture', subName: 'Livestock management and improvement' }, 
  { id: 16, name: 'Agriculture', subName: 'Livestock/veterinary services' }, 
  { id: 17, name: 'Agriculture', subName: 'Plant and post-harvest protection and pest control' },
  
  { id: 18, name: 'Children', subName: 'Children' },
  { id: 19, name: 'Community Development', subName: 'Community Development' }, 
  { id: 20, name: 'Cultural Heritage, Preservation and Protection', subName: 'Cultural Heritage, Preservation and Protection' },
  { id: 21, name: 'Disabled People', subName: 'Disabled People' }, 
  { id: 22, name: 'Disaster Risk Reduction and Preparedness', subName: 'DRR Education' }, 
  { id: 23, name: 'Disaster Risk Reduction and Preparedness', subName: 'Emergency Contingency' },
  { id: 24, name: 'Disaster Risk Reduction and Preparedness', subName: 'Early warning systems' },
  { id: 25, name: 'Disaster Risk Reduction and Preparedness', subName: 'Preparedness Training' },
  { id: 26, name: 'Economic Recovery and Development', subName: 'Economic Recovery and Development' },
  
  { id: 27, name: 'Education', subName: 'Early Childhood Education' },
  { id: 28, name: 'Education', subName: 'Education Facilities' },
  { id: 29, name: 'Education', subName: 'Education Policy and Administrative Management Capacity Building' },
  { id: 30, name: 'Education', subName: 'Educational Research' },
  { id: 31, name: 'Education', subName: 'Educator Training' },
  { id: 32, name: 'Education', subName: 'Higher Education' },
  { id: 33, name: 'Education', subName: 'Life-Skills for Adults' },
  { id: 34, name: 'Education', subName: 'Life-Skills for Youth' },
  { id: 35, name: 'Education', subName: 'Primary Education' },
  { id: 36, name: 'Education', subName: 'Secondary Education' },
  { id: 37, name: 'Education', subName: 'Vocational Training' },

  { id: 38, name: 'Emergency Response', subName: 'Material relief assistance and services' },
  { id: 39, name: 'Emergency Response', subName: 'Emergency food aid' },
  { id: 40, name: 'Emergency Response', subName: 'Relief co-ordination: protection and support services' },
  
  { id: 41, name: 'Energy and Extractives', subName: 'Energy and Extractives' },
  { id: 42, name: 'Environment', subName: 'Environment' },
  { id: 43, name: 'Food Security', subName: 'Food Security' },
  { id: 44, name: 'Forestry', subName: 'Forestry' },
  { id: 45, name: 'Financial Services', subName: 'Financial Services' },
  { id: 46, name: 'Fishing', subName: 'Fishing' },

  { id: 47, name: 'Health, Nutrition and Population', subName: 'Basic Healthcare' },
  { id: 48, name: 'Health, Nutrition and Population', subName: 'Basic Nutrition' },
  { id: 49, name: 'Health, Nutrition and Population', subName: 'Disease Control' },
  { id: 50, name: 'Health, Nutrition and Population', subName: 'Family Planning' },
  { id: 51, name: 'Health, Nutrition and Population', subName: 'Health Education' },
  { id: 52, name: 'Health, Nutrition and Population', subName: 'Healthcare Infrastructure' },
  { id: 53, name: 'Health, Nutrition and Population', subName: 'Health, Medical Education / Training' },
  { id: 54, name: 'Health, Nutrition and Population', subName: 'Health Policy and Administrative Management Capacity Building' },
  { id: 55, name: 'Health, Nutrition and Population', subName: 'Medical Research' },
  { id: 56, name: 'Health, Nutrition and Population', subName: 'Medical Services' },
  { id: 57, name: 'Health, Nutrition and Population', subName: 'Reproductive Healthcare' },
  { id: 58, name: 'Health, Nutrition and Population', subName: 'STD Control, incl. HIV/AIDS' },

  { id: 59, name: 'Human Rights, Civil Liberties and Governance', subName: 'Anti-corruption' },
  { id: 60, name: 'Human Rights, Civil Liberties and Governance', subName: 'Democratic Participation and Civil Society' },
  { id: 61, name: 'Human Rights, Civil Liberties and Governance', subName: 'Elections' },
  { id: 62, name: 'Human Rights, Civil Liberties and Governance', subName: 'Immigration and Asylum Services' },
  { id: 63, name: 'Human Rights, Civil Liberties and Governance', subName: 'Legal and Judicial Development' },
  { id: 64, name: 'Human Rights, Civil Liberties and Governance', subName: 'Media and Free Flow of Information' },
  { id: 65, name: 'Human Rights, Civil Liberties and Governance', subName: 'National Monitoring and Evaluation' },
  { id: 66, name: 'Human Rights, Civil Liberties and Governance', subName: 'Protection of Human Rights and Civil Liberties' },
  { id: 67, name: 'Human Rights, Civil Liberties and Governance', subName: 'Protection of Women and Girls' },
  { id: 68, name: 'Human Rights, Civil Liberties and Governance', subName: 'Public Policy and Administrative Management Capacity Building' },
  { id: 69, name: 'Human Rights, Civil Liberties and Governance', subName: 'Security System Reform' },
  { id: 70, name: 'Human Rights, Civil Liberties and Governance', subName: 'Womens Equality' },

  { id: 71, name: 'ICT - Information and Communication Technology', subName: 'Statistical capacity building' },
  { id: 72, name: 'Indigenous People', subName: 'Indigenous People' },
  { id: 73, name: 'Media and Journalism', subName: 'Media and Journalism' },

  { id: 74, name: 'Peace and Security', subName: 'Peace-Building, Conflict Prevention and Resolution' },
  { id: 75, name: 'Peace and Security', subName: 'Prevention and demobilisation of child soldiers' },
  { id: 76, name: 'Peace and Security', subName: 'Reintegration and SALW control' },
  { id: 77, name: 'Peace and Security', subName: 'Removal of land mines and explosive remnants of war' },

  { id: 78, name: 'Post-Disaster Reconstruction and Rehabilitation', subName: 'Restoration of basic infrastructure' },
  { id: 79, name: 'Post-Disaster Reconstruction and Rehabilitation', subName: 'Social Rehabilitation' },
  { id: 80, name: 'Post-Disaster Reconstruction and Rehabilitation', subName: 'Economic Rehabilitation' },

  { id: 81, name: 'Public Sector and Civil Society Capacity Building', subName: 'Public Sector and Civil Society Capacity Building' },
  { id: 82, name: 'Refugees', subName: 'Refugees' },
  { id: 83, name: 'Rural Development', subName: 'Rural Development' },

  { id: 84, name: 'Social Infrastructure and Services', subName: 'Low Cost Housing' },
  { id: 85, name: 'Social Infrastructure and Services', subName: 'Social mitigation of HIV/AIDS' },
  { id: 86, name: 'Social Infrastructure and Services', subName: 'Social Protection / Welfare Policy and Administrative Management Capacity Building' },
  { id: 87, name: 'Social Infrastructure and Services', subName: 'Social Security' },
  { id: 88, name: 'Social Infrastructure and Services', subName: 'Social Services Education / Training' },
  { id: 89, name: 'Social Infrastructure and Services', subName: 'Social Welfare' },

  { id: 90, name: 'Shelter and Housing', subName: 'Shelter and Housing' },
  { id: 91, name: 'Urban Development', subName: 'Urban Development' },

  { id: 92, name: 'Water, Sanitation and Hygiene', subName: 'Basic Sanitation' },
  { id: 93, name: 'Water, Sanitation and Hygiene', subName: 'Basic Water and Sanitation' },
  { id: 94, name: 'Water, Sanitation and Hygiene', subName: 'Basic Water Supply' },
  { id: 95, name: 'Water, Sanitation and Hygiene', subName: 'Education in Water and Sanitation' },
  { id: 96, name: 'Water, Sanitation and Hygiene', subName: 'River Basins Development' },
  { id: 97, name: 'Water, Sanitation and Hygiene', subName: 'Sanitation - Large Systems' },

  { id: 98, name: 'Water, Sanitation and Hygiene', subName: 'Waste Management / Disposal' },
  { id: 99, name: 'Water, Sanitation and Hygiene', subName: 'Water and Sanitation - Large Systems' },
  { id: 100, name: 'Water, Sanitation and Hygiene', subName: 'Water and Sanitation Policy' },
  { id: 101, name: 'Water, Sanitation and Hygiene', subName: 'Water Resource Conservation' },
  { id: 102, name: 'Water, Sanitation and Hygiene', subName: 'Water Supply - Large Systems' },
  { id: 103, name: 'Women and Girls', subName: 'Women and Girls' },
  { id: 104, name: 'Civil Society Capacity Building', subName: 'Civil Society Capacity Building' },
  { id: 105, name: 'Construction', subName: 'Construction' },
]

  user: IUser = {
    projSpecs: []
  }
  get projSpecs(): FormArray {
    return this.projectForm.get('projSpecs') as FormArray;
  }
  projectSpecs(): FormArray {
    const ayspec = this.projectSpecialization.map(s => {
      return this.formBuilder.group({
        selected: false,
        id: s.id
      });
    });
    return this.formBuilder.array(ayspec);
  }

  forminit(){
    return this.formBuilder.group({
       projectType: ['', Validators.required],
       name: ['', Validators.required],
       projectDescription: ['', Validators.required],
       projectAddress: ['', Validators.required],
       startDate: [''],
       endDate: [''],
       numHouseholdsAffected: ['', Validators.required],
 
       interventionmechanisms: this.formBuilder.array([
         this.initInterventionMechanisms()
       ]),
 
       leads: this.formBuilder.array([
         this.initLeads(),
       ]),
 
       projectWebsite: ['', Validators.required],
       projectFacebooksite: [''],
       projectTwittersite: [''],
       projectYoutubesite: [''],
       projectLinkedInsite: [''],
 
       challenges: [''],
       projSpecs: this.projectSpecs(),
 
       partnerOrganizations: this.formBuilder.array([
         this.initPartnerOrg()
       ]),
       budget: new FormControl('', Validators.compose([Validators.required, Validators.pattern(/^([A-Z!#$%&₹￥'*]{0,3})?[ ]?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[1-9][0-9!#$%&₹￥'*!A-Z]{0,5})?$/)])),
       spent: new FormControl('', Validators.compose([null, Validators.pattern(/^([A-Z!#$%&₹￥'*]{0,3})?[ ]?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[1-9][0-9!#$%&₹￥'*!A-Z]{0,5})?$/)])),
     });
   }

  ngOnInit() {

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["geocode"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.projectForm.controls['projectAddress'].setValue(place.formatted_address)
          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 10;
          this.displayErrorMessage = false;
        });
      });
    });

    this.projSpecializations = [];

    /*--------------MultipleFile Arrays--------*/
    this.detailsArray = [];
    this.challengesArray = [];
    this.partnersArray = [];
    this.projectsArray = [];
    /*--------------MultipleFile Arrays--------*/
    this.partnerOrganizations = [];
    this.leads = [];
    this.interventionMechanisms = [];

    this.currentdetailsMulti = [];
    this.currentchallengesMulti = [];
    this.currentpartnerlistMulti = [];
    this.currentimagesMulti = [];
    this.projects = [];

    var userid = this.storageService.getItem('userid')
    if (!userid) {
      //this.alert.showToast1("You have tried to access a memeber only Area. Please Sign Up and Sign In to contiue registration");
      this.storageService.addItem('auth2reg', "Please Sign in to register your organization");
      this.utility.signInWithMessageId("auth2reg");
    }
    this.projectForm=this.forminit()
     this.subscription = this.route.params.subscribe(
      (param: any) => {
        this.storageService.addMode("mode", param.mode);
        if (param.mode === 'edit') {
          this.newmode = false;
          param.profileId ? this.projectService.getProject(param.profileId)
            .subscribe(
            res => {

              this.projects = [];

              this.projects.push(res);
              if (this.projects[0]['projSpecialization'] === undefined || this.projects[0]['projSpecialization'] === null) {
                this.projects[0]['projSpecialization'] = [];

              };
              if (this.projects[0]['interventionmechanisms'] === undefined) {
                this.projects[0]['interventionmechanisms'] === [];
              }

              this.storageService.addItem("projectid", param.profileId);

              this.storageService.addItem('projLatitude', this.projects[0]['latitude'])
              this.storageService.addItem('projLongitude', this.projects[0]['longitude'])
              this.storageService.addItem('orgnizationId', this.projects[0]['orgId'])
              this.storageService.addItem('projSpecialization', this.projects[0]['projSpecialization'])
              if (this.projects[0] !== null || this.projects[0] !== undefined) {

                this.projectForm = this.formBuilder.group({
                  projectType: [this.projects[0]['projectType'], Validators.required],
                  name: [this.projects[0]['name'], Validators.required],
                  projectDescription: [this.projects[0]['projectDescription'], Validators.required],
                  projectAddress: [this.projects[0]['projectAddress'], Validators.required],
                  startDate: [this.projects[0]['startDate']],

                  endDate: [this.projects[0]['endDate']],
                  numHouseholdsAffected: [this.projects[0]['numHouseholdsAffected'], Validators.required],
                  interventionmechanisms: this.formBuilder.array([]),
                  leads: this.formBuilder.array([]),
                  projectWebsite: [this.projects[0]['projectWebsite'], Validators.required],
                  projectFacebooksite: [this.projects[0]['projectFacebook']],
                  projectTwittersite: [this.projects[0]['projectTwitter']],
                  projectYoutubesite: [this.projects[0]['projectYoutube']],
                  projectLinkedInsite: [this.projects[0]['projectLinkedin']],
                  orgspecializations: [this.projects[0]['orgspecializations']],
                  projSpecs: this.buildaySpecsAfterFetch(this.projects[0]['projSpecialization']),

                  challenges: [this.projects[0]['challenges'], Validators.required],

                  partnerOrganizations: this.formBuilder.array([]),

                  budget: [this.projects[0]['budget'], Validators.compose([Validators.required, Validators.pattern(/^([A-Z!#$%&₹￥'*]{0,3})?[ ]?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[1-9][0-9!#$%&₹￥'*!A-Z]{0,5})?$/)])],
                  spent: [this.projects[0]['spent'], Validators.compose([null, Validators.pattern(/^([A-Z!#$%&₹￥'*]{0,3})?[ ]?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[1-9][0-9!#$%&₹￥'*!A-Z]{0,5})?$/)])],

                })




                //--------Array Forms function for edit-------
                this.interventionArray()
                this.leadsArray()
                this.partnerOrganizationsArray()
                //--------Array Forms function for edit-------
                //--------@Riyan End Date disable validation---------
                this.disablePreviousDates = this.projects[0]['startDate']
                //--------@Riyan End Date disable validation---------
                if (this.projects[0]['projectcoverPhoto'] == null || this.projects[0]['projectprofilePhoto'] == null) {

                  // todo
                  // please handle this

                } else {

                  this.imageSrc = this.projects[0]['projectcoverPhoto']['url'];
                  this.imageSrcName = this.projects[0]['projectcoverPhoto']['name'];
                  this.profileimageSrc = this.projects[0]['projectprofilePhoto']['url'];
                  this.profileimageName = this.projects[0]['projectprofilePhoto']['name'];
                }



                //---------Image Preview Project Details----------
                if (this.projects[0]['projectDetails'] == undefined || this.projects[0]['projectDetails'] == null) {

                } else {

                  for (var i = 0; i < this.projects[0]['projectDetails'].length; i++) {

                    var projectDetailsObj = {
                      'name': '' + this.projects[0]['projectDetails'][i].name,
                      'imgSrc': '' + this.projects[0]['projectDetails'][i].url,
                      'remove': true
                    }
                    this.detailsArray.push(projectDetailsObj)

                  }
                }
                //---------Image Preview Project Details----------         
                //---------Image Preview Project Challenges----------
                if (this.projects[0]['projectChallenges'] == undefined || this.projects[0]['projectChallenges'] == null) {

                } else {

                  for (var i = 0; i < this.projects[0]['projectChallenges'].length; i++) {

                    var projectChallengesObj = {
                      'name': '' + this.projects[0]['projectChallenges'][i].name,
                      'imgSrc': '' + this.projects[0]['projectChallenges'][i].url,
                      'remove': true
                    }
                    this.challengesArray.push(projectChallengesObj)

                  }
                }
                //---------Image Preview Project Challenges----------    
                //---------Image Preview Project PartnerList----------
                if (this.projects[0]['projectPartnersList'] == undefined || this.projects[0]['projectPartnersList'] == null) {

                } else {

                  for (var i = 0; i < this.projects[0]['projectPartnersList'].length; i++) {

                    var projectPartnersListObj = {
                      'name': '' + this.projects[0]['projectPartnersList'][i].name,
                      'imgSrc': '' + this.projects[0]['projectPartnersList'][i].url,
                      'remove': true
                    }
                    this.partnersArray.push(projectPartnersListObj)

                  }
                }
                //---------Image Preview Project PartnerList----------  
                //---------Image Preview Project Images---------------
                if (this.projects[0]['projectImages'] == undefined || this.projects[0]['projectImages'] == null) {

                } else {

                  for (var i = 0; i < this.projects[0]['projectImages'].length; i++) {

                    var projectImagesObj = {
                      'name': '' + this.projects[0]['projectImages'][i].name,
                      'imgSrc': '' + this.projects[0]['projectImages'][i].url,
                      'remove': true
                    }
                    this.projectsArray.push(projectImagesObj)

                  }
                }
                //---------Image Preview Project Images---------------                 
              }
            }) : null;


        }
      }
    );
   



    var mode = this.storageService.getMode("mode");
    var lat = this.storageService.getItem('projLatitude')


    if (mode === 'edit') {
      if (lat === '' || lat === undefined || lat === null || lat === 'undefined') {

        this.setCurrentPosition();
        this.displayErrorMessage = true;
        this.errorMessage = 'Project Address not resolved on Map. Please edit and save.';
      } else {
        this.getProjPosition()
        this.displayErrorMessage = false;

      }
    } else {
      this.setCurrentPosition();


    }
    var projSpecialization = this.storageService.getItem('projSpecialization')
    if (mode === 'edit') {
      if (projSpecialization !== '' || projSpecialization !== undefined) {
        var orgid = this.storageService.getItem('orgnizationId')
      } else {
      }
    } else {
      var orgid = this.storageService.getItem('orgId')

    }



    this.organizationService.getOrganization(orgid)
      .subscribe(
      res => {
        this.specialz = res.specializations;
 
        if(this.specialz==="undefined"||this.specialz===''||this.specialz===undefined)
        {
          this.specialz=[];
        }
        else{

      
        this.specialz.forEach(resos => {

          this.projectSpecialization.forEach(resps => {
            if (resps.name === resos.name) {
            }
          })
        })

      }
    }

      )

  }


  buildaySpecsAfterFetch(specializations): FormArray {

    if (specializations != '' || specializations != 'undefined' || specializations != undefined) {
      const arr = this.projectSpecialization.map(s => {
        return this.formBuilder.group({
          selected: [JSON.stringify(specializations).indexOf(s['subName']) > 0 ? true : null],
          id: s.id
        });
      })
      return this.formBuilder.array(arr);
    } else {
      const arr = this.projectSpecialization.map(s => {
        return this.formBuilder.group({
          selected: false,
          id: s.id
        });
      });
      return this.formBuilder.array(arr);
    }
  }



  //**** Start interventionmechanisms *****//

  initInterventionMechanisms(): FormGroup {
    return this.formBuilder.group({
      interName: [],
      interDescription: []
    });
  }


  addInterventionMechanisms() {
    const control = <FormArray>this.projectForm.get('interventionmechanisms');
    control.push(this.initInterventionMechanisms());
  }

  removeInterventionMechanisms(i: number) {
    const control = <FormArray>this.projectForm.get('interventionmechanisms');
    control.removeAt(i);
  }
  //**** End interventionmechanisms *****//
  //-----------InterventionArray------------

  interventionArray() {

    if (this.projects[0]['interventionmechanisms'] === null || this.projects[0]['interventionmechanisms'] === undefined || this.projects[0]['interventionmechanisms'] === 'undefined' || this.projects[0]['interventionmechanisms'] === '') {

      this.addInterventionMechanisms()
    } else {

      const interventionArray = <FormArray>this.projectForm.controls['interventionmechanisms'];

      this.projects[0]['interventionmechanisms'].forEach(y => {

        interventionArray.push(this.initInterventionMechanismsAfterFetch(y.interName, y.interDescription))
      })
    }
  }
  //-----------InterventionArray------------

  initInterventionMechanismsAfterFetch(x, y): FormGroup {



    if (x != undefined && y != undefined) {
      return this.formBuilder.group({

        interName: [x],
        interDescription: [y],

      });
    }
    else {

      return this.formBuilder.group({

        interName: [],
        interDescription: []

      });

    }
  }

  initLeads(): FormGroup {
    return this.formBuilder.group({
      leadName: [],
      leadEmail: [],
      leadPhone: []

    });
  }

  addLeads() {
    const control = <FormArray>this.projectForm.get('leads');
    control.push(this.initLeads());
  }
  removeLeads(i: number) {
    const control = <FormArray>this.projectForm.controls['leads'];
    control.removeAt(i);
  }

  initLeadAfterFetch(x, y, z): FormGroup {


    if (x != undefined) {
      return this.formBuilder.group({

        leadName: [x],
        leadEmail: [y],
        leadPhone: [z]
      });
    }
    else {

      return this.formBuilder.group({

        leadName: [],
        leadEmail: [],
        leadPhone: []

      });

    }

  }

  //-----------LeadsArray------------
  leadsArray() {

    if (this.projects[0]['leads'] === null || this.projects[0]['leads'] === undefined || this.projects[0]['leads'] === 'undefined' || this.projects[0]['leads'] === '') {

      this.addLeads()
    } else {

      const leadsArray = <FormArray>this.projectForm.controls['leads'];
      this.projects[0]['leads'].forEach(y => {

        leadsArray.push(this.initLeadAfterFetch(y.leadName, y.leadEmail, y.leadPhone))
      })
    }
  }
  //-----------LeadsArray------------
  //**** Start PartnerOrg *****//

  initPartnerOrg(): FormGroup {
    return this.formBuilder.group({
      partnerName: [],
      partnershipDetails: []
    });
  }

  addPartnerOrganizations() {
    const control = <FormArray>this.projectForm.get('partnerOrganizations');
    control.push(this.initPartnerOrg());
  }

  removePartnerOrganizations(i: number) {
    const control = <FormArray>this.projectForm.get('partnerOrganizations');
    control.removeAt(i);
  }

  initPartnerOrganizationsAfterFetch(x, y): FormGroup {


    if (x != undefined) {
      return this.formBuilder.group({

        partnerName: [x],
        partnershipDetails: [y],

      });
    }
    else {

      return this.formBuilder.group({

        partnerName: [],
        partnershipDetails: [],


      });

    }

  }
  //-----------PartnerOrganizationsArray------------
  partnerOrganizationsArray() {

    if (this.projects[0]['partnerOrganizations'] === null || this.projects[0]['partnerOrganizations'] === undefined || this.projects[0]['partnerOrganizations'] === 'undefined' || this.projects[0]['partnerOrganizations'] === '') {

      this.addPartnerOrganizations()
    } else {

      const partnerOrganizationsArray = <FormArray>this.projectForm.controls['partnerOrganizations'];
      this.projects[0]['partnerOrganizations'].forEach(y => {

        partnerOrganizationsArray.push(this.initPartnerOrganizationsAfterFetch(y.partnerName, y.partnershipDetails))
      })
    }
  }
  //-----------PartnerOrganizationsArray------------

  //**** End PartnerOrg*****//


  onChange(files: FileList) {
    this.files = files;
  }

  selectProjectcoverimagesFile(event) {
    this.hideCoverPhotoProgress = false;
    this.selectedprojectcoverimagesFiles = event.target.files;
    if (this.selectedprojectcoverimagesFiles.length == 0) {
      this.selectedprojectcoverimagesFiles = null;
      return false;
    } else {
      this.imageSrcName = event.target.files[0].name;
      var file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];

      var pattern = /image-*/;
      var reader = new FileReader();

      if (!file.type.match(pattern)) {
        alert('invalid format');
        return;
      }

      this.loaded = false;

      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsDataURL(file);
    }
  }


  projectcoverimagesUpload() {
    this.hideCoverPhotoProgress = true;
    const file = this.selectedprojectcoverimagesFiles.item(0)
    this.projectcoverimagesFileUpload = new FileUpload(file);
    this.upSvc.pushFileToStorage(this.projectcoverimagesFileUpload, this.projectcoverimagesProgress)
    this.selectedprojectcoverimagesFiles = null;
  }



  // start project profile images

  selectProjectprofileimagesFile(event) {
    this.hideProfilePhotoProgress = false;
    this.selectedprojectprofileimagesFiles = event.target.files;
    if (this.selectedprojectprofileimagesFiles.length == 0) {
      this.selectedprojectprofileimagesFiles = null;
      return false;
    } else {
      this.profileimageName = event.target.files[0].name;
      var file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];
      var pattern = /image-*/;
      var reader1 = new FileReader();
      if (!file.type.match(pattern)) {
        alert('invalid format');
        return;
      }
      this.profileloaded = false;
      reader1.onload = this._handleprofileReaderLoaded.bind(this);
      reader1.readAsDataURL(file);
    }
  }

  projectprofileimagesUpload() {
    this.hideProfilePhotoProgress = true;
    const file = this.selectedprojectprofileimagesFiles.item(0)
    this.projectprofileimagesFileUpload = new FileUpload(file);
    this.upSvc.pushFileToStorage(this.projectprofileimagesFileUpload, this.projectprofileimagesProgress)
    this.selectedprojectprofileimagesFiles = null
  }

  //@Divya 
  //***Start projectdetails *//
  detectprojectdetailsFiles(event) {
    this.hideProjectDetailProgress = false;
    this.detailsArray = [];
    this.selectedprojectdetailsFiles = event.target.files;

    //@Riyan: Validation for disabling upload button
    if (this.selectedprojectdetailsFiles.length == 0) {
      this.selectedprojectdetailsFiles = null;
    } else {
      for (var i = 0; i < this.selectedprojectdetailsFiles.length; i++) {
        var file = this.selectedprojectdetailsFiles[i];
        var fileName = this.selectedprojectdetailsFiles[i].name

        this.projectDetailsPreviewFunction(file)
      }
    }
  }

  projectDetailsPreviewFunction(file) {
    //Only for Pics
    if (file.type.match('image')) {

      var picReader = new FileReader();
      picReader.onload = (e: any) => {

        var reader = e.target;
        var detailsObj = {
          'imgSrc': reader.result,
          'name': '' + file.name
        }
        this.detailsArray.push(detailsObj)

      }
      picReader.readAsDataURL(file)
      //Only for Pics
    } else {
      //Only for Documents

      var docReader = new FileReader();
      docReader.onload = (e: any) => {

        var reader = e.target;
        var detailsObj = {
          'imgSrc': '../assets/img/doc.jpg',
          'name': '' + file.name
        }
        this.detailsArray.push(detailsObj)

      }
      docReader.readAsDataURL(file)
      //Only for Documents
    }
  }

  projectdetailsuploadMulti() {
    this.hideProjectDetailProgress = true;
    let files = this.selectedprojectdetailsFiles
    let filesIndex = _.range(files.length)
    _.each(filesIndex, (idx) => {
      this.projectdetailsUpload = new Upload(files[idx]);
      this.upSvc.pushUpload(this.projectdetailsUpload)
      this.currentdetailsMulti.push(this.projectdetailsUpload)
      this.selectedprojectdetailsFiles = null;
      this.detailsArray = [];
    }
    )
  }
  //@Divya:Deleting ProjectDetails Files from Screen and Database
  deleteDetails(upload) {

    let index = this.detailsArray.indexOf(upload);
    this.detailsArray.splice(index, 1);
    this.projects[0]['projectDetails'].splice(index, 1)
  }
  //***End  projectdetails *//

  //***Start projectchallenges *//
  detectprojectchallengesFiles(event) {
    this.hideProjectChallengesProgress = false;
    this.challengesArray = [];
    this.selectedprojectchallengesFiles = event.target.files;

    //@Riyan: Validation for disabling upload button
    if (this.selectedprojectchallengesFiles.length == 0) {
      this.selectedprojectchallengesFiles = null;
    } else {
      for (var i = 0; i < this.selectedprojectchallengesFiles.length; i++) {
        var file = this.selectedprojectchallengesFiles[i];
        var fileName = this.selectedprojectchallengesFiles[i].name

        this.projectChallengesPreviewFunction(file)
      }
    }
  }

  projectChallengesPreviewFunction(file) {
    //Only for Pics
    if (file.type.match('image')) {

      var picReader = new FileReader();
      picReader.onload = (e: any) => {

        var reader = e.target;
        var challengesObj = {
          'imgSrc': reader.result,
          'name': '' + file.name //../assets/img/doc.jpg
        }
        this.challengesArray.push(challengesObj)

      }
      picReader.readAsDataURL(file)
      //Only for Pics
    } else {
      //Only for Documents

      var docReader = new FileReader();
      docReader.onload = (e: any) => {

        var reader = e.target;
        var challengesObj = {
          'imgSrc': '../assets/img/doc.jpg',
          'name': '' + file.name
        }
        this.challengesArray.push(challengesObj)

      }
      docReader.readAsDataURL(file)
      //Only for Documents
    }
  }
  projectchallengesuploadMulti() {
    this.hideProjectChallengesProgress = true;
    let files = this.selectedprojectchallengesFiles

    let filesIndex = _.range(files.length)
    _.each(filesIndex, (idx) => {
      this.projectchallengesUpload = new Upload(files[idx]);

      this.upSvc.pushUpload(this.projectchallengesUpload)
      this.currentchallengesMulti.push(this.projectchallengesUpload)
      this.selectedprojectchallengesFiles = null;
      this.challengesArray = [];

    }
    )
  }

  //@Divya:Deleting ProjectChallenges Files from Screen and Database
  deleteChallenges(upload) {

    let index = this.challengesArray.indexOf(upload);
    this.challengesArray.splice(index, 1);
    this.projects[0]['projectChallenges'].splice(index, 1)
  }

  //***End projectchallenges *//

  //***Start Project PartnerList *//
  detectprojectpartnerslistFiles(event) {
    this.hideProjectPartnersProgress = false;
    this.partnersArray = [];
    this.selectedprojectpartnerslistFiles = event.target.files;

    //@Riyan: Validation for disabling upload button
    if (this.selectedprojectpartnerslistFiles.length == 0) {
      this.selectedprojectpartnerslistFiles = null;
    } else {
      for (var i = 0; i < this.selectedprojectpartnerslistFiles.length; i++) {
        var file = this.selectedprojectpartnerslistFiles[i];
        var fileName = this.selectedprojectpartnerslistFiles[i].name

        this.projectPartnersPreviewFunction(file)
      }
    }
  }

  projectPartnersPreviewFunction(file) {
    //Only for Pics
    if (file.type.match('image')) {

      var picReader = new FileReader();
      picReader.onload = (e: any) => {

        var reader = e.target;
        var partnerObj = {
          'imgSrc': reader.result,
          'name': '' + file.name //../assets/img/doc.jpg
        }
        this.partnersArray.push(partnerObj)

      }
      picReader.readAsDataURL(file)
      //Only for Pics
    } else {
      //Only for Documents

      var docReader = new FileReader();
      docReader.onload = (e: any) => {

        var reader = e.target;
        var partnerObj = {
          'imgSrc': '../assets/img/doc.jpg',
          'name': '' + file.name
        }
        this.partnersArray.push(partnerObj)

      }
      docReader.readAsDataURL(file)
      //Only for Documents
    }
  }

  projectpartnerslistuploadMulti() {
    this.hideProjectPartnersProgress = true;
    let files = this.selectedprojectpartnerslistFiles;

    let filesIndex = _.range(files.length)
    _.each(filesIndex, (idx) => {
      this.projectpartnerlistUpload = new Upload(files[idx]);
      this.upSvc.pushUpload(this.projectpartnerlistUpload)
      this.currentpartnerlistMulti.push(this.projectpartnerlistUpload)
      this.selectedprojectpartnerslistFiles = null;
      this.partnersArray = [];
    }
    )
  }
  //@Divya:Deleting Projectpartnerslist Files from Screen and Database
  deletePartners(upload) {

    let index = this.partnersArray.indexOf(upload);
    this.partnersArray.splice(index, 1);
    this.projects[0]['projectPartnersList'].splice(index, 1)
  }
  //***End  projectpartnerslist *//

  //***Start projectimages *//
  detectprojectimagesFiles(event) {
    this.hideProjectImagesProgress = false;
    this.projectsArray = [];
    this.selectedprojectimagesFiles = event.target.files;

    //@Riyan: Validation for disabling upload button
    if (this.selectedprojectimagesFiles.length == 0) {
      this.selectedprojectimagesFiles = null;
    } else {
      for (var i = 0; i < this.selectedprojectimagesFiles.length; i++) {
        var file = this.selectedprojectimagesFiles[i];
        var fileName = this.selectedprojectimagesFiles[i].name

        this.projectImagesPreviewFunction(file)
      }
    }
  }

  projectImagesPreviewFunction(file) {
    //Only for Pics
    if (file.type.match('image')) {

      var picReader = new FileReader();
      picReader.onload = (e: any) => {

        var reader = e.target;
        var projectImageObj = {
          'imgSrc': reader.result,
          'name': '' + file.name //../assets/img/doc.jpg
        }
        this.projectsArray.push(projectImageObj)

      }
      picReader.readAsDataURL(file)
      //Only for Pics
    } else {
      //Only for Documents

      var docReader = new FileReader();
      docReader.onload = (e: any) => {

        var reader = e.target;
        var projectImageObj = {
          'imgSrc': '../assets/img/doc.jpg',
          'name': '' + file.name
        }
        this.projectsArray.push(projectImageObj)

      }
      docReader.readAsDataURL(file)
      //Only for Documents
    }
  }
  projectimagesuploadMulti() {
    this.hideProjectImagesProgress = true;
    let files = this.selectedprojectimagesFiles

    let filesIndex = _.range(files.length)
    _.each(filesIndex, (idx) => {
      this.projectimagesUpload = new Upload(files[idx]);
      this.upSvc.pushUpload(this.projectimagesUpload)
      this.currentimagesMulti.push(this.projectimagesUpload)
      this.selectedprojectimagesFiles = null;
      this.projectsArray = [];
    }
    )
  }
  //@Divya:Deleting File from Screen and Database
  deleteImages(upload) {

    let index = this.projectsArray.indexOf(upload);
    this.projectsArray.splice(index, 1);
    this.projects[0]['projectImages'].splice(index, 1)
  }
  //***End  projectimages *//
  //@Divya 
  //* Start cancel button by venkat//

  cancel() {
    var orgId = this.storageService.getItem("orgid");
    this.router.navigate(["/org/" + orgId]);
  }

  //* End cancel button by venkat//


  saveproject(add: boolean) {




    this.processData();

    var proj: LooseObject = null;
    proj = this.projects[0];

    var strSvc: LooseObject = null;
    strSvc = this.storageService;

    var db: LooseObject = null;
    db = this.db;

    var router: LooseObject = null;
    router = this.router;

    var orgid = this.storageService.getItem('orgid');
    var userid = this.storageService.getItem('userid');
    var projectid = this.storageService.getItem('projectid');
    var mode = this.storageService.getItem('mode');

    var pushId = uuid();

    if (mode === 'edit')
      pushId = projectid;
    proj['projectid'] = pushId;

    var currentTime = new Date();
    var day = currentTime.getDate();

    var month = currentTime.getMonth();
    //here we are adding 1 to month because when we are getting month number,
    // even it is octber it will give us 9 because january starts from 0 not 1
    month = (month + 1);

    var year = currentTime.getFullYear();

    var currentDate = currentTime.toString();
    var completeDate = currentDate.slice(15, 33);
    var date = month + '-' + day + '-' + year + '' + completeDate;
    proj['createdon'] = date;

    proj['createdBy'] = userid;
    let listObjectObservable = db.object('/organizations/');
    listObjectObservable.$ref.child(orgid + "/projects/" + pushId + "/").update(proj);

    db.object('/projects/' + pushId).set(
      proj
    );


    if (!add)
      this.router.navigateByUrl("/project/" + pushId);

    else {
      this.projects = [];
      this.projectForm.reset();
      this.resetFunction()
      this.router.navigateByUrl("/registerproject/new/new")
      document.body.scrollTop = document.documentElement.scrollTop = 0;

    }





  }
  //@Riyan:- Disable date---
  dateDisable() {

    this.disablePreviousDates = this.projectForm.controls['startDate'].value;
  }
  //@Riyan:- Disable date---
  saveGeoCodeResults(status, x, proj, storageService, db, router, add: boolean, parent) {


    var orgid = storageService.getItem('orgid');
    var userid = storageService.getItem('userid');
    var projectid = storageService.getItem('projectid');
    var mode = storageService.getItem('mode');

    if (status == 'ok') {

      var res = x.toString().replace("(", "").replace(")", "").split(",");
      proj['latitude'] = res[0].toString();
      proj['longitude'] = res[1].toString();

    } else {


    }


    var pushId = uuid();

    if (mode === 'edit')
      pushId = projectid;
    proj['projectid'] = pushId;

    var currentTime = new Date();
    var day = currentTime.getDate();

    var month = currentTime.getMonth();
    //here we are adding 1 to month because when we are getting month number,
    // even it is octber it will give us 9 because january starts from 0 not 1
    month = (month + 1);

    var year = currentTime.getFullYear();

    var currentDate = currentTime.toString();
    var completeDate = currentDate.slice(15, 33);

    var date = month + '-' + day + '-' + year + '' + completeDate;
    proj['createdon'] = date;

    proj['createdBy'] = userid;
    let listObjectObservable = db.object('/organizations/');
    listObjectObservable.$ref.child(orgid + "/projects/" + pushId + "/").update(proj);


    db.object('/projects/' + pushId).set(
      proj
    );


    if (!add)
      router.navigateByUrl("/project/" + pushId);

    else {
      parent.projects = [];
      parent.projectForm.reset();
      parent.resetFunction()
      router.navigateByUrl("/registerproject/new/new")
      document.body.scrollTop = document.documentElement.scrollTop = 0;

    }


  }

  resetFunction() {
    
    this.projectForm=this.forminit()
    this.projSpecializations=[];
    this.detailsArray = [];
    this.challengesArray = [];
    this.partnersArray = [];
    this.projectsArray = [];

    this.currentdetailsMulti = [];
    this.currentchallengesMulti = [];
    this.currentpartnerlistMulti = [];
    this.currentimagesMulti = [];
    //this.specialz = [];

    this.interventionMechanisms = [];
    this.partnerOrganizations = [];
    this.leads = [];

    this.coverPhotoInputVariable.nativeElement.value = "";
    this.profilePhotoInputVariable.nativeElement.value = "";
    this.projectDetailVariable.nativeElement.value = "";
    this.projectChallengesVariable.nativeElement.value = "";
    this.projectPartnersVariable.nativeElement.value = "";
    this.projectImagesVariable.nativeElement.value = "";

    this.hideCoverPhotoProgress = false;
    this.hideProfilePhotoProgress = false;
    this.hideProjectDetailProgress = false;
    this.hideProjectChallengesProgress = false;
    this.hideProjectPartnersProgress = false;
    this.hideProjectImagesProgress = false;

    this.selectedprojectprofileimagesFiles = null;
    this.selectedprojectcoverimagesFiles = null;
    this.selectedprojectdetailsFiles = null;
    this.selectedprojectchallengesFiles = null;
    this.selectedprojectpartnerslistFiles = null;
    this.selectedprojectimagesFiles = null;


    this.projectForm.controls['interventionmechanisms'] = this.formBuilder.array([this.initInterventionMechanisms()]);
    this.projectForm.controls['partnerOrganizations'] = this.formBuilder.array([this.initPartnerOrg()]);
    this.projectForm.controls['leads'] = this.formBuilder.array([this.initLeads()]);

  }



  saveandaddproject() {

    this.saveproject(true);

    this.setCurrentPosition();
    //this.projectSpecialization=[];
  }

  // Push the project data

  processData() {

    this.specialz.forEach(resos => {
      const mine: any[] = <any[]>this.projectForm.value.projSpecs.filter(x => x.selected);
      this.user.projSpecs = <ProjectSpecializations[]>mine.map(x => this.projectSpecialization.find(y => y.id === x.id));
      for (var i = 0; i < this.user.projSpecs.length; i++) {
        var thad = this.user.projSpecs[i]['name'];
        if (resos.name.includes(thad)) {
          this.projSpecializations.push(this.user.projSpecs[i]['subName'])
        }
      }
    })




    this.projectForm.value.leads.forEach(element => {
      this.leads.push({
        'leadName': element.leadName,
        'leadEmail': element.leadEmail,
        'leadPhone': element.leadPhone
      });
    });

    this.projectForm.value.partnerOrganizations.forEach(element => {
      this.partnerOrganizations.push({
        'partnerName': element.partnerName,
        'partnershipDetails': element.partnershipDetails
      });
    });
    this.projectForm.value.interventionmechanisms.forEach(element => {
      this.interventionMechanisms.push({
        'interName': element.interName,
        'interDescription': element.interDescription
      });
    });

    var coverPhoto = { url: '', name: '' };
    if (this.projectcoverimagesFileUpload == null || this.projectcoverimagesFileUpload == undefined) {
      coverPhoto.url = "/assets/img/default_projectcover_img.jpg";
      coverPhoto.name = 'default_projectcover_img.jpg';
      //-------Riyan-------------------------------------------------------------
      var modeForImage = this.storageService.getItem('mode')
      if (modeForImage === 'edit') {
        if (this.projects[0]['projectcoverPhoto'] === null || this.projects[0]['projectprofilePhoto'] === null || this.projects[0]['projectcoverPhoto'] === 'undefined' || this.projects[0]['projectcoverPhoto'] === undefined) {

        } else {
          
          coverPhoto.url = this.projects[0]['projectcoverPhoto']['url'];
          coverPhoto.name = this.projects[0]['projectcoverPhoto']['name'];
        }
      }
      //-------Riyan-------------------------------------------------------------      
    } else {
      coverPhoto.url = this.projectcoverimagesFileUpload.url;
      coverPhoto.name = this.projectcoverimagesFileUpload.name;
    }

    var profilePhoto = { url: '', name: '' };
    if (this.projectprofileimagesFileUpload == null || this.projectprofileimagesFileUpload == undefined) {
      profilePhoto.url = "/assets/img/default_projectprofile_img.jpg";
      profilePhoto.name = 'default_projectprofile_img.jpg';
      //-------Riyan-------------------------------------------------------------
      var modeForImage = this.storageService.getItem('mode')
      if (modeForImage === 'edit') {
        if (this.projects[0]['projectcoverPhoto'] === null || this.projects[0]['projectprofilePhoto'] === null || this.projects[0]['projectcoverPhoto'] === 'undefined' || this.projects[0]['projectcoverPhoto'] === undefined) {

        } else {
          
          profilePhoto.url = this.projects[0]['projectprofilePhoto']['url'];
          profilePhoto.name = this.projects[0]['projectprofilePhoto']['name'];
        }
      }
      //-------Riyan-------------------------------------------------------------      
    } else {
      profilePhoto.url = this.projectprofileimagesFileUpload.url;
      profilePhoto.name = this.projectprofileimagesFileUpload.name;
    }
    //--------------------Get Multiple Files for Project Details--------------------

    if (this.currentdetailsMulti == null || this.currentdetailsMulti.length == 0) {

      var modeForProjectDetailsChallengesFiles = this.storageService.getItem('mode')
      if (modeForProjectDetailsChallengesFiles === 'edit') {


        if (this.projects[0]['projectDetails'] == undefined || this.projects[0]['projectDetails'] == null) {

        } else {

          for (var i = 0; i < this.projects[0]['projectDetails'].length; i++) {

            var projectDetailsObj = {
              'name': '' + this.projects[0]['projectDetails'][i].name,
              'imgSrc': '' + this.projects[0]['projectDetails'][i].url,
            }
            this.currentdetailsMulti.push(this.projects[0]['projectDetails'][i])
            this.detailsArray.push(projectDetailsObj)
          }
        }
      }
    } else {

    }
    //--------------------Get Multiple Files for Project Details--------------------
    //--------------------Get Multiple Files for Project Challenges--------------------

    if (this.currentchallengesMulti == null || this.currentchallengesMulti.length == 0) {

      var modeForProjectChallengesFiles = this.storageService.getItem('mode')
      if (modeForProjectChallengesFiles === 'edit') {


        if (this.projects[0]['projectChallenges'] == undefined || this.projects[0]['projectChallenges'] == null) {

        } else {

          for (var i = 0; i < this.projects[0]['projectChallenges'].length; i++) {

            var projectChallengesObj = {
              'name': '' + this.projects[0]['projectChallenges'][i].name,
              'imgSrc': '' + this.projects[0]['projectChallenges'][i].url,
            }
            this.currentchallengesMulti.push(this.projects[0]['projectChallenges'][i])
            this.challengesArray.push(projectChallengesObj)
          }
        }
      }
    } else {

    }
    //--------------------Get Multiple Files for Project Challenges--------------------
    //--------------------Get Multiple Files for Project PartnerList--------------------

    if (this.currentpartnerlistMulti == null || this.currentpartnerlistMulti.length == 0) {

      var modeForProjectPartnerFiles = this.storageService.getItem('mode')
      if (modeForProjectPartnerFiles === 'edit') {


        if (this.projects[0]['projectPartnersList'] == undefined || this.projects[0]['projectPartnersList'] == null) {

        } else {

          for (var i = 0; i < this.projects[0]['projectPartnersList'].length; i++) {

            var projectPartnersList = {
              'name': '' + this.projects[0]['projectPartnersList'][i].name,
              'imgSrc': '' + this.projects[0]['projectPartnersList'][i].url,
            }
            this.currentpartnerlistMulti.push(this.projects[0]['projectPartnersList'][i])
            this.partnersArray.push(projectPartnersList)
          }
        }
      }
    } else {

    }
    //--------------------Get Multiple Files for Project PartnerList--------------------
    //--------------------Get Multiple Files for Project Images--------------------

    if (this.currentimagesMulti == null || this.currentimagesMulti.length == 0) {

      var modeForProjectImagesFiles = this.storageService.getItem('mode')
      if (modeForProjectImagesFiles === 'edit') {


        if (this.projects[0]['projectImages'] == undefined || this.projects[0]['projectImages'] == null) {

        } else {

          for (var i = 0; i < this.projects[0]['projectImages'].length; i++) {

            var projectImagesObj = {
              'name': '' + this.projects[0]['projectImages'][i].name,
              'imgSrc': '' + this.projects[0]['projectImages'][i].url,
            }
            this.currentimagesMulti.push(this.projects[0]['projectImages'][i])
            this.projectsArray.push(projectImagesObj)
          }
        }
      }
    } else {

    }
    //--------------------Get Multiple Files for Project Images--------------------                  

    this.projects = [];

    // venkat start 18-11-2017
    this.websiteUrl = this.projectForm.value.projectWebsite;

    if (this.websiteUrl === '' || this.websiteUrl === null || this.websiteUrl === undefined) {

      this.webAddress = '';
    } else {

      if (this.websiteUrl.indexOf('www') >= 0) {

        if (this.websiteUrl.indexOf('http') >= 0) {

          this.webAddress = this.websiteUrl;
        }
        else {

          this.webAddress = 'http://' + this.websiteUrl
        }

      } else {

        if (this.websiteUrl.indexOf('http') >= 0) {
          this.webAddress = this.websiteUrl;
        } else {
          this.webAddress = 'http://' + this.websiteUrl
        }
      }
    }
    // venkat end 18-11-2017
    // venkat start 22-11-2017
        
 this.facebookUrl = this.projectForm.value.projectFacebooksite;
 if (this.facebookUrl === '' || this.facebookUrl === null || this.facebookUrl === undefined) {
     this.facebookAddress = '';
 } else {

 if (this.facebookUrl.indexOf('facebook.com') >= 0) {
     if(this.facebookUrl.indexOf('http') >= 0){
         this.facebookAddress = this.facebookUrl;
     }
     else{
         this.facebookAddress = 'https://'+this.facebookUrl
     }
    
 }
 else {
     this.facebookUrl = this.projectForm.value.projectFacebooksite.replace('/', "");
     this.facebookAddress = 'https://www.facebook.com/' + this.facebookUrl
 }
}
 this.twitterUrl = this.projectForm.value.projectTwittersite;
 if (this.twitterUrl === '' || this.twitterUrl === null || this.twitterUrl === undefined) {
     this.twitterAddress = '';
 } else {
 if (this.twitterUrl.indexOf('twitter.com') >= 0) {
     if(this.twitterUrl.indexOf('http') >= 0){
         this.twitterAddress = this.twitterUrl;
     }
     else{
         this.twitterAddress = 'https://'+this.twitterUrl
     }
    
 }
 else {
     this.twitterUrl = this.projectForm.value.projectTwittersite.replace('/', "");
     this.twitterAddress = 'https://www.twitter.com/' + this.twitterUrl
 }
}
 this.youtubeUrl = this.projectForm.value.projectYoutubesite;
 if (this.youtubeUrl === '' || this.youtubeUrl === null || this.youtubeUrl === undefined) {
     this.youtubeAddress = '';
 } else {
 if (this.youtubeUrl.indexOf('youtube.com') >= 0) {
     if(this.youtubeUrl.indexOf('http') >= 0){
         this.youtubeAddress = this.youtubeUrl;
     }
     else{
         this.youtubeAddress = 'https://'+this.youtubeUrl
     }
 }
 else {
     this.youtubeUrl = this.projectForm.value.projectYoutubesite.replace('/', "");
     this.youtubeAddress = 'https://www.youtube.com/' + this.youtubeUrl
 }
}
 this.linkedinUrl = this.projectForm.value.projectLinkedInsite;
 if (this.linkedinUrl === '' || this.linkedinUrl === null || this.linkedinUrl === undefined) {
     this.linkedinAddress = '';
 } else {
 if (this.linkedinUrl.indexOf('linkedin.com') >= 0) {
     if(this.linkedinUrl.indexOf('http') >= 0){
         this.linkedinAddress = this.linkedinUrl;
     }
     else{
         this.linkedinAddress = 'https://'+this.linkedinUrl
     }
     
 }
 else {
     this.linkedinUrl = this.projectForm.value.projectLinkedInsite.replace('/', "");
     this.linkedinAddress = 'https://www.linkedin.com/' + this.linkedinUrl
 }
}
 // venkat end 22-11-2017



    this.projects.push({
      'projectType': this.projectForm.value.projectType,
      'name': this.projectForm.value.name,
      'orgId': this.storageService.getItem('orgid'),
      'orgName': this.storageService.getItem('orgName'),
      'startDate': this.projectForm.value.startDate,
      'endDate': this.projectForm.value.endDate,
      'numHouseholdsAffected': this.projectForm.value.numHouseholdsAffected,
      'projectDescription': this.projectForm.value.projectDescription,
      'projectAddress': this.projectForm.value.projectAddress,
      'leads': this.leads,
      'budget': this.projectForm.value.budget,
      'spent': this.projectForm.value.spent,
      'challenges': this.projectForm.value.challenges,
      'partnerOrganizations': this.partnerOrganizations,
      'interventionmechanisms': this.interventionMechanisms,

      'orgspecializations': this.specialz,
      'projSpecialization': this.projSpecializations,
      'projectcoverPhoto': coverPhoto,
      'projectprofilePhoto': profilePhoto,

      'projectDetails': this.currentdetailsMulti,
      'projectChallenges': this.currentchallengesMulti,
      'projectPartnersList': this.currentpartnerlistMulti,
      'projectImages': this.currentimagesMulti,

      'projectWebsite': this.webAddress,
      'projectFacebook': this.facebookAddress,
      'projectTwitter': this.twitterAddress,
      'projectYoutube': this.youtubeAddress,
      'projectLinkedin': this.linkedinAddress,
      'latitude': this.latitude,
      'longitude': this.longitude

    });
  }

  private convertStringToNumber(value: string): number {
    return +value;
  }

}


interface LooseObject {
  [key: string]: any
}

interface ProjectSpecializations {
  id: any;
  name: string;
  subName: string;
}

interface IUser {
  projSpecs: ProjectSpecializations[]
}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/+forms/registerproject/registerproject.component.ts